export default __webpack_public_path__ + "static/media/timeIcon.6ed352ec.svg";